import {
  postBulkUplaod,
  PascalCaseBulkUploadRequest,
  CamelCaseBulkUpload,
  CamelCaseBulkUploadRecord,
} from 'api/agent';
import { Button, Upload, message } from 'antd';
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import type { RcFile } from 'antd/es/upload/interface';
import { csv2json } from 'json-2-csv';
import { mkConfig, generateCsv, download } from 'export-to-csv';

const BulkUploadPage = () => {
  function handleDownload(_e: any) {
    debugger;
    // getBulkUplaodTemplate().then((bulkUploadRequestList: BulkUploadRequest[]) => {
    //   debugger
    //   const csvConfig = mkConfig({ useKeysAsHeaders: true });
    //   const csv = generateCsv(csvConfig)(bulkUploadRequestList);
    //   download(csvConfig)(csv)
    // });

    const bulkUploadRequest: PascalCaseBulkUploadRequest = {
      LoanNumber: '',
      PaymentPurpose: '',
    };
    const bulkUploadRequestList: PascalCaseBulkUploadRequest[] = [];
    bulkUploadRequestList.push(bulkUploadRequest);
    const fileName = `Bulk Upload - ${new Date().toLocaleDateString()}`;
    const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: fileName });
    const csv = generateCsv(csvConfig)(bulkUploadRequestList);
    download(csvConfig)(csv);
  }

  const handleBeforeUpload = (file: RcFile) => {
    const bulkUploadFileName = file.name;
    if (bulkUploadFileName.endsWith('.csv')) {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        const csvString: any = e.target?.result;
        const csvLineArray = csvString.toString().split('\r\n');
        csvLineArray.pop();
        const formatedCsv = csvLineArray.join('\n');
        const options = {
          delimiter: {
            wrap: '"', // Double Quote (") character
            field: ',', // Comma field delimiter
            eol: '\n', // Newline delimiter
          },
        };

        const header = csvLineArray[0];

        csv2json(formatedCsv, options)
          .then((pascalCaseBulkUploadRequestList: PascalCaseBulkUploadRequest[]) => {
            let columnLoanNumberMissing = false;
            let columnPaymentPurposeMissing = false;
            const camelCaseBulkUploadRecordList = pascalCaseBulkUploadRequestList.map(
              (pascalCaseBulkUploadRequest, index) => {
                columnLoanNumberMissing = pascalCaseBulkUploadRequest.LoanNumber ? false : true;
                columnPaymentPurposeMissing = pascalCaseBulkUploadRequest.PaymentPurpose
                  ? false
                  : true;
                const camelCaseBulkUploadRequest: CamelCaseBulkUploadRecord = {
                  loanNumber: pascalCaseBulkUploadRequest.LoanNumber,
                  paymentPurpose: pascalCaseBulkUploadRequest.PaymentPurpose,
                  recordId: index + 1,
                };
                return camelCaseBulkUploadRequest;
              }
            );
            const camelCaseBulkUpload: CamelCaseBulkUpload = {
              bulkUploadRecordList: camelCaseBulkUploadRecordList,
              fileName: bulkUploadFileName,
              totalRecord: camelCaseBulkUploadRecordList.length,
              userEmailId: sessionStorage.getItem('user')?.toString(),
              partnerId: Number(sessionStorage.getItem('partnerId')),
              sourceId: sessionStorage.getItem('sourceId')?.toString(),
              createdBy: Number(sessionStorage.getItem('userId')),
            };
            debugger;
            if (header.toString().split(',').length > 2) {
              message.error(`Uploaded CSV Contains more then required column`);
            } else if (camelCaseBulkUpload.totalRecord < 10) {
              message.error(
                `Uploaded CSV Contains ${camelCaseBulkUpload.totalRecord}, which is Less Than required count of 10`
              );
            }
            else if (camelCaseBulkUpload.totalRecord > 5000) {
              message.error(
                `Uploaded CSV Contains ${camelCaseBulkUpload.totalRecord}, which is More Than required count of 5000`
              );
            }
            else if (columnLoanNumberMissing) {
              message.error(`Column "LoanNumber" is Missing`);
            } else if (columnPaymentPurposeMissing) {
              message.error(`Column "PaymentPurpose" is Missing`);
            } else {
              debugger;
              postBulkUplaod(camelCaseBulkUpload).then((resp) => {
                debugger;
                console.log(resp);
                if (resp.bulkUploadFileId > 0) {
                  message.success(
                    `File Uploaded Succesfully for Processing with File Id - ${resp.bulkUploadFileId}`
                  );
                } else {
                  message.error(`Failed to upload the file as ${resp.errorMessage}`);
                }
              });
            }
          })
          .catch((err: any) => console.log('ERROR: ' + err.message));
      };
      reader.readAsText(file);
    } else {
      message.error(`Only CSV File Alllowed to Upload`);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6">
          <Button type="primary" size="large" icon={<DownloadOutlined />} onClick={handleDownload}>
            Download Template
          </Button>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6">
          <Upload accept=".csv" showUploadList={false} beforeUpload={handleBeforeUpload}>
            <Button type="primary" size="large" icon={<UploadOutlined />}>
              Upload File
            </Button>
          </Upload>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadPage;
